const roles = ['USER', 'ADMIN'];

export default roles;